import "core-js/modules/es.regexp.constructor.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.object.assign.js";
import UA from '../ua';
import Env from '../env';
import Platform from '../platform';
import Url from './url';
import KNB from '@dp/knb';
import Cookie from './cookie';
import ACTIVITY_TAG from '../config/activityTag';
import { TJBridge } from '../platform/tengjing';
import parseUrl from 'url-parse';
import KNBCore from '@mtfe/knb-core';
function isCrawlEnabled(url) {
  // lion api 白名单
  var lionApiConfig = localStorage.getItem('limitApiLionConfig');
  var lionApiConfigArr = lionApiConfig ? lionApiConfig.split(',') : [];
  var lionApiRegex = new RegExp(lionApiConfigArr.join('|'));

  // 前端路由白名单: 详情页、票档页 旧选座分区页、旧选座页、新选座页、确认订单页。
  var limitRoutes = ['/detail', '/ticket-level', '/movieshoworder/select-seats.html', '/myshowfe/trade/seat', '/movieshoworder/pre-order.html'];
  var limitRouterRegex = new RegExp(limitRoutes.join('|'));
  return lionApiConfigArr.length && lionApiRegex.test(url) || limitRouterRegex.test(location.href);
}
function compareVersions(version1, version2) {
  // 将版本号拆分为数组
  var v1 = version1.split('.').map(Number);
  var v2 = version2.split('.').map(Number);
  // 获取最长的版本号长度
  var maxLength = Math.max(v1.length, v2.length);
  // 循环比较每一部分的版本号
  for (var i = 0; i < maxLength; i++) {
    var num1 = v1[i] || 0; // 如果v1长度不够，补0
    var num2 = v2[i] || 0; // 如果v2长度不够，补0
    if (num1 > num2) {
      return true;
    } else if (num1 < num2) {
      return false;
    }
  }
  // 如果所有部分都相等，返回true
  return true;
}
var KNBP = KNB.getPromiseInstance();
var urlPerfix = Platform.urlPerfix,
  _Platform$linkMap = Platform.linkMap,
  linkMap = _Platform$linkMap === void 0 ? {} : _Platform$linkMap;
var isProduct = Env.isProduct,
  isPpe = Env.isPpe,
  isLocal = Env.isLocal;
var showUrlRegx = /\/(myshow|movieshow|movieshowlist|movieshoworder|selfsale)\/?/;
var raletiveUrlCover = function raletiveUrlCover(url) {
  // 处理相对路径跳转问题
  var Href = location.href;
  var uri = Url.parse(Href).uri;
  if (/(^[?#&]|\/$)/.test(url)) url = uri + url;else {
    var str = uri.split('/').pop() + '/?$';
    url = uri.replace(new RegExp(str), url);
  }
  return url;
};
export var getUrl = function getUrl(url) {
  url = url.trim();

  // if (!/^\//.test(url)) url = raletiveUrlCover(url)

  var _Url$parse = Url.parse(url),
    uri = _Url$parse.uri,
    hash = _Url$parse.hash,
    query = _Url$parse.query;

  // 兼容运营位置以前运营用乱带fromTag的问题
  if (query) {
    var activityTag = query[ACTIVITY_TAG.STATS_TAG] || query[ACTIVITY_TAG.FROM_TAG];
    if (query[ACTIVITY_TAG.FROM_TAG]) delete query[ACTIVITY_TAG.FROM_TAG];
    if (activityTag) query[ACTIVITY_TAG.STATS_TAG] = activityTag;
  }
  /** 灰度测试专用 */
  var isGray = location.search.includes('isshowgray=true');
  if (isGray) query.isshowgray = true;
  var isGray2 = location.search.includes('isshow2gray=true');
  if (isGray2) query.isshow2gray = true;
  /** 灰度测试专用 */

  // 演出相关路径 需要特殊处理， 以处理路径映射 及 fromTag 问题等
  if (showUrlRegx.test(uri)) {
    // 携带 fromTag
    var fromTag = Url.getQuery('fromTag') || Url.getQuery('utm_source') || Url.getHashQuery('utm_source');
    if (fromTag) query.fromTag = query.utm_source = fromTag;

    // cookie 中含有 ACTIVITY_TAG.STATS_TAG 需要带到下个链接
    var utmContent = '';
    var utmCookie = Cookie.get('_lx_utm');
    if (utmCookie) {
      var utm = Url.parseQuery(utmCookie);
      Object.keys(utm).forEach(function (key) {
        if (key === ACTIVITY_TAG.STATS_TAG) {
          utmContent = utm[key];
        }
      });
    }
    if (utmContent && !query[ACTIVITY_TAG.STATS_TAG]) query[ACTIVITY_TAG.STATS_TAG] = utmContent;

    // 清理前缀
    uri = uri.replace(/^(.*\.com\/app\/)/, '/');

    // 判断是否包含地址映射
    if (linkMap[uri]) uri = linkMap[uri];

    // 替换域名路径替换域名路径
    url = Url.stringify(urlPerfix.replace(/[?#/&]$/, '') + uri, query, hash);
    if (!/^https?/.test(url)) url = location.protocol + url;
  }
  if (url.includes('myshowfe')) {
    url = url.replace(/\/app|\/qqw/, '');
  }
  return url;
};
var redirect = function redirect(url) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    jump: false,
    _blank: true
  };
  var IS_NEW_CALENDAR_PAGE = url.includes('/myshow/#/new-calendar');
  var IS_SHOW_HOME_PAGE = url === '/myshow/index.html';
  var jump = options.jump,
    _blank = options._blank,
    unFormate = options.unFormate;
  url = unFormate ? url : getUrl(url);
  if (isLocal) {
    url = url.replace('/app/myshow', '');
  }

  /** 灰度测试专用 */
  var isGray = location.search.includes('isshowgray=true');
  if (isGray) {
    var _Url$parse2 = Url.parse(url),
      uri = _Url$parse2.uri,
      hash = _Url$parse2.hash,
      query = _Url$parse2.query;
    query.isshowgray = true;
    url = Url.stringify(uri, query, hash);
  }
  var isGray2 = location.search.includes('isshow2gray=true');
  if (isGray2) {
    var _Url$parse3 = Url.parse(url),
      _uri = _Url$parse3.uri,
      _hash = _Url$parse3.hash,
      _query = _Url$parse3.query;
    _query.isshow2gray = true;
    url = Url.stringify(_uri, _query, _hash);
  }
  /** 灰度测试专用 */

  if (UA.IS_TENGJING) {
    // 腾竞 APP 页面跳转
    return TJBridge.openWebview({
      url: url,
      jump: jump
    });
  }

  // 工行
  if (UA.IS_SHENZHEN_ICBC) {
    location.href = url;
  }
  // 美团小程序直接新开webview页面
  if (window.Drip && window.Drip.UA.IS_WXAPP_MEITUAN) {
    var webviewUrl = "/index/pages/h5/h5?weburl=" + encodeURIComponent(url);
    wx.miniProgram.navigateTo({
      url: webviewUrl,
      fail: function fail(e) {
        window.owl && window.owl('addError', {
          name: "\u7F8E\u56E2\u5C0F\u7A0B\u5E8F window.wx.miniProgram.navigateTo fail-".concat(e.errMsg),
          msg: {
            miniUrl: miniUrl,
            errro: e,
            drip: window.Drip
          }
        }, {
          category: 'jsError',
          level: 'error'
        });
      }
    });
    return;
  }

  // 抖音演出小程序
  if (UA.IS_DouyinShowMicroApp) {
    var result = url.match(/.*#\/detail\/(\d+).*/);
    var _miniUrl = "/pages/show/webview/webview?url=" + encodeURIComponent(url);
    if (result && result[1] && /isNewPage=true/.test(url)) {
      // 项目详情页面跳转, 旧的项目详情地址
      _miniUrl = "/pages/show/detail/index?id=".concat(result[1], "&isNewPage=true");
    }
    window.tt.miniProgram.navigateTo({
      url: _miniUrl,
      fail: function fail(e) {
        window.owl && window.owl('addError', {
          name: "\u6296\u97F3\u6F14\u51FA\u5C0F\u7A0B\u5E8F window.tt.miniProgram.navigateTo fail-".concat(e.errMsg),
          msg: {
            miniUrl: _miniUrl,
            errro: e,
            drip: window.Drip
          }
        }, {
          category: 'jsError',
          level: 'error'
        });
      }
    });
    return;
  }

  //小红书演出小程序
  if (UA.IS_MAOYAN_XHS_APP || UA.IS_MAOYAN_XHSMOVIE) {
    // const result = url.match(/.*#\/detail\/(\d+).*/)
    var _miniUrl2 = "/pages/show/webview/webview?url=" + encodeURIComponent(url);
    // if (result && result[1]) {
    //   // 项目详情页面跳转, 旧的项目详情地址
    //   miniUrl = `/pages/show/detail/index?id=${result[1]}`
    // }

    window.xhs.miniProgram.navigateTo({
      url: _miniUrl2,
      fail: function fail(e) {
        window.owl && window.owl('addError', {
          name: "\u5C0F\u7EA2\u4E66\u6F14\u51FA\u5C0F\u7A0B\u5E8F window.xhs.miniProgram.navigateTo fail-".concat(e.errMsg),
          msg: {
            miniUrl: _miniUrl2,
            errro: e,
            drip: window.Drip
          }
        }, {
          category: 'jsError',
          level: 'error'
        });
      }
    });
    return;
  }
  //百度演出小程序
  if (UA.IS_MAOYAN_BAIDU_APP) {
    // const result = url.match(/.*#\/detail\/(\d+).*/)
    var _miniUrl3 = "/pages/show/webview/webview?url=" + encodeURIComponent(url);
    // if (result && result[1]) {
    //   // 项目详情页面跳转, 旧的项目详情地址
    //   miniUrl = `/pages/show/detail/index?id=${result[1]}`
    // }
    window.swan.webView.navigateTo({
      url: _miniUrl3,
      fail: function fail(e) {
        window.owl && window.owl('addError', {
          name: "\u767E\u5EA6\u6F14\u51FA\u5C0F\u7A0B\u5E8F window.xhs.miniProgram.navigateTo fail-".concat(e.errMsg),
          msg: {
            miniUrl: _miniUrl3,
            errro: e,
            drip: window.Drip
          }
        }, {
          category: 'jsError',
          level: 'error'
        });
      }
    });
    return;
  }
  if (UA.isNative && url.includes('closekey')) {
    var _Url$parse4 = Url.parse(url),
      _uri2 = _Url$parse4.uri,
      _hash2 = _Url$parse4.hash,
      _query2 = _Url$parse4.query;
    _query2.closekey = Url.getHashQuery('closekey', url);
    /* eslint-disable-next-line no-param-reassign */
    url = Url.stringify(_uri2, _query2, _hash2);

    // 解决KNB.closePageWithKeys在点评iOS上不生效问题
    // https://km.sankuai.com/page/1303599853
    if (UA.IS_DIANPING && UA.osName === 'ios') {
      /* eslint-disable-next-line no-param-reassign */
      url = "imeituan://www.meituan.com/web?url=".concat(encodeURIComponent(url));
    }
  }
  if (isLocal || !UA.isNative || /^(dianping|imeituan):\/\//.test(url)) {
    // 本地 或者 非Native环境 或者 带协议的链接 直接跳转
    location.href = url;
    return;
  }
  if (_blank === undefined) _blank = true;
  var qs = {
    noquery: 1
  };
  if (UA.isNative && _blank) {
    var queryStr = '&notitlebar=1&future=2';

    // 新日历页面美团、点评、猫眼渠道均隐藏native导航栏，h5自渲染导航栏样式

    if (IS_NEW_CALENDAR_PAGE) {
      if (UA.IS_DIANPING) {
        var _url = 'dianping://web?noquery=1&notitlebar=1&future=2&url=' + encodeURIComponent(url + queryStr);
        var aEl = document.createElement('a');
        aEl.href = _url;
        aEl.click();
        return;
      }
      if (UA.IS_MAOYAN) {
        if (compareVersions(UA.appVersion, '9.57.0')) {
          var _url2 = 'maoyan://maoyan.com/web?noquery=1&notitlebar=1&future=2&url=' + encodeURIComponent(url + queryStr);
          var _aEl = document.createElement('a');
          _aEl.href = _url2;
          _aEl.click();
          return;
        }
      }
      if (UA.IS_MEITUAN) {
        var _url3 = 'imeituan://www.meituan.com/web?noquery=1&notitlebar=1&future=2&url=' + encodeURIComponent(url + queryStr);
        var _aEl2 = document.createElement('a');
        _aEl2.href = _url3;
        _aEl2.click();
        return;
      }
    }
    if (IS_SHOW_HOME_PAGE) {
      // 首页隐藏native导航栏，h5自渲染顶部导航栏(本期不涉及点评渠道)
      if (UA.IS_MAOYAN) {
        if (compareVersions(UA.appVersion, '9.57.0')) {
          var _url4 = 'maoyan://maoyan.com/web?noquery=1&notitlebar=1&future=2&url=' + encodeURIComponent(url + queryStr);
          var _aEl3 = document.createElement('a');
          _aEl3.href = _url4;
          _aEl3.click();
          return;
        }
      }
      if (UA.IS_MEITUAN) {
        if (compareVersions(UA.appVersion, '12.22.200')) {
          var _url5 = 'imeituan://www.meituan.com/web?noquery=1&notitlebar=1&future=2&url=' + encodeURIComponent(url + queryStr);
          var _aEl4 = document.createElement('a');
          _aEl4.href = _url5;
          _aEl4.click();
          return;
        }
      }
      if (UA.IS_DIANPING) {
        if (compareVersions(UA.appVersion, '11.24.0')) {
          var _url6 = 'dianping://web?noquery=1&notitlebar=1&future=2&url=' + encodeURIComponent(url + queryStr);
          var _aEl5 = document.createElement('a');
          _aEl5.href = _url6;
          _aEl5.click();
          return;
        }
      }
    }

    // native 环境默认使用 openwebview 方式
    if (UA.IS_MEITUAN) {
      // wkwebview 切换
      var needWkWebview;
      try {
        needWkWebview = KNB.Semver.gte(UA.appVersion, '9.10.6');
      } catch (e) {
        console.error(e);
      }
      if (jump) {
        return KNB.jumpWebview({
          url: url,
          qs: Object.assign({}, qs, {
            wkwebview: needWkWebview ? 1 : 0
          })
        });
      } else {
        // 美团跳转需要特殊处理， 兼容老版美团版本 knb 不支持情况
        url = "imeituan://www.meituan.com/web?noquery=1".concat(needWkWebview ? '&wkwebview=1' : '', "&url=") + encodeURIComponent(url);
        var a = document.createElement('a');
        a.href = url;
        a.click();
      }
      return;
    }
    if (!jump && UA.IS_MAOYAN && UA.osName === 'android') {
      // 猫眼 android 跳转需要特殊处理， 手机端需要唤起摄像头
      if (KNBCore.compareVersion(UA.appVersion, '9.20.0') >= 0) {
        // android 9.20.0 版本后要把concert_verify参数放在url里
        var urlObj = parseUrl(url, true);
        urlObj.set('query', Object.assign({}, urlObj.query, {
          concert_verify: 1
        }));
        url = urlObj.toString();
        url = "meituanmovie://www.meituan.com/web?url=".concat(encodeURIComponent(url));
      } else {
        url = "meituanmovie://www.meituan.com/web?url=".concat(encodeURIComponent(url), "#concert_verify");
      }
      var _a = document.createElement('a');
      _a.href = url;
      _a.click();
      return;
    }
    if (jump) return KNBP.jumpWebview({
      url: url
    });
    return KNBP.openPage({
      url: url,
      qs: qs
    });
  }
  location.href = url;
};
redirect.getUrl = getUrl;
export default redirect;